import { reportPageViewToAnalytics } from '../analyticsOperations';
import Module from '../../../application/Service/Module';

export const handleRouteComponentMount = () =>
{
    reportPageViewToAnalytics();
    Module.get().scroll && Module.get().scroll(0, 0);
};
